const SDK_VERSION = "10.65.0" ;

export { SDK_VERSION };
//# sourceMappingURL=version.js.map
